import { render, staticRenderFns } from "./EditInspiration.vue?vue&type=template&id=595e6d11&"
import script from "./EditInspiration.vue?vue&type=script&lang=js&"
export * from "./EditInspiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports